/* Article: Journal template (sections/article-journal.liquid) */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  /* Not .is-visible: Turbo's styles.css forces that class to display:block !important */
  var SHOWN = 'aj-in';

  function reveal(root) {
    var items = root.querySelectorAll('[data-aj-reveal]');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add(SHOWN); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(SHOWN);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function progress(root) {
    var bar = root.querySelector('[data-aj-progress]');
    var body = root.querySelector('.aj-body');
    if (!bar || !body) return;
    var ticking = false;
    function update() {
      var rect = body.getBoundingClientRect();
      var span = Math.max(1, rect.height - window.innerHeight * 0.6);
      var p = Math.min(1, Math.max(0, -rect.top / span));
      bar.style.transform = 'scaleX(' + p + ')';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* Posts without a banner: the menu floats over the page, so push the title below it */
  function clearFloatingNav(root) {
    if (!root.classList.contains('aj--no-banner')) return;
    function measure() {
      var header = document.querySelector('[data-desktop-header].feature_image');
      var h = 0;
      if (header && header.offsetParent !== null) {
        var bar = header.querySelector('.header');
        if (bar && getComputedStyle(bar).position === 'absolute') h = bar.offsetHeight;
      }
      root.style.setProperty('--aj-nav-clear', h + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
  }

  /* Product cards (shop grid) and product rows (in the article) share [data-aj-card] */
  function addToCart(btn) {
    var card = btn.closest('[data-aj-card]');
    var status = card && card.querySelector('[data-aj-status]');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    if (status) status.textContent = '';

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok) throw new Error(json.description || 'Could not add to bag.');
          return json;
        });
      })
      .then(function () {
        btn.textContent = 'Added';
        if (status) status.innerHTML = '<a href="' + ROOT + 'cart">View bag</a>';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
      })
      .catch(function (err) {
        btn.textContent = label;
        btn.disabled = false;
        if (status) status.textContent = err.message;
      });
  }

  function selectVariant(select) {
    var card = select.closest('[data-aj-card]');
    if (!card) return;
    var btn = card.querySelector('[data-aj-atc]');
    var price = card.querySelector('[data-aj-price]');
    var option = select.options[select.selectedIndex];
    if (btn) btn.setAttribute('data-variant-id', select.value);
    if (price && option && option.getAttribute('data-price')) price.textContent = option.getAttribute('data-price');
    var status = card.querySelector('[data-aj-status]');
    if (status) status.textContent = '';
  }

  function copyLink(btn) {
    var url = btn.getAttribute('data-url');
    if (!navigator.clipboard || !url) return;
    navigator.clipboard.writeText(url).then(function () {
      var label = btn.textContent;
      btn.textContent = 'Link copied';
      setTimeout(function () { btn.textContent = label; }, 1600);
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-aj-ready')) return;
    root.setAttribute('data-aj-ready', '1');
    root.classList.add('aj--js');
    reveal(root);
    progress(root);
    clearFloatingNav(root);
    root.addEventListener('click', function (e) {
      var atc = e.target.closest('[data-aj-atc]');
      if (atc) { addToCart(atc); return; }
      var copy = e.target.closest('[data-aj-copy]');
      if (copy) copyLink(copy);
    });
    root.addEventListener('change', function (e) {
      var select = e.target.closest('[data-aj-variant]');
      if (select) selectVariant(select);
    });
  }

  function initAll() { document.querySelectorAll('[data-aj]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
